import { render, staticRenderFns } from "./InstructionsCollection.vue?vue&type=template&id=39723ada&scoped=true&"
import script from "./InstructionsCollection.vue?vue&type=script&lang=ts&"
export * from "./InstructionsCollection.vue?vue&type=script&lang=ts&"
import style0 from "./InstructionsCollection.vue?vue&type=style&index=0&id=39723ada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39723ada",
  null
  
)

export default component.exports